import { useCallback } from 'react';
import { getIndexByLetter } from './utils';
import { useSearchString } from './useSearchString';
export var useOnComboType = function useOnComboType(_ref) {
  var items = _ref.items,
      index = _ref.index;

  var _useSearchString = useSearchString(),
      getSearchString = _useSearchString.getSearchString,
      resetSearchString = _useSearchString.resetSearchString;

  return useCallback(function (letter) {
    // Находим индекс первого подходящего item
    var updatedSearchString = getSearchString(letter);
    var searchIndex = getIndexByLetter(items.map(function (item) {
      return item.label;
    }), updatedSearchString, index + 1); // Если есть подходящая опция - переходим к ней

    if (searchIndex >= 0) {
      return searchIndex;
    }

    resetSearchString();
    return undefined;
  }, [items, index, getSearchString, resetSearchString]);
};